import { useContext, useEffect, useState } from 'react';
import { AppContext } from 'App.context';
import { ApiContext } from '../../../utils/networking/Api.context';

export default function useLanguageSelector(onChange, isMultiple = false) {
  const { API } = useContext(ApiContext);
  const [languages, setLanguages] = useState([]);
  const { appState } = useContext(AppContext);

  const [selectedLanguageCode, setSelectedLanguageCode] = useState(
    isMultiple ? [] : null
  );

  useEffect(() => {
    async function loadLanguages() {
      try {
        const response = await API.languagesRequest();
        setLanguages(response);

        if (response.length) {
          const currentLang = response.find(
            l => l.code === appState.currentLanguage.id
          );
          const selectedLang = currentLang || response[0];

          if (isMultiple) {
            setSelectedLanguageCode([selectedLang.code]);
            onChange?.([selectedLang]);
          } else {
            setSelectedLanguageCode(selectedLang.code);
            onChange?.(selectedLang);
          }
        }
      } catch (error) {
        console.error('Failed loading languages', error);
      }
    }

    loadLanguages();
  }, [appState.selectedHotel]);

  function selectLanguage(code) {
    setSelectedLanguageCode(code);
    const lang = languages.find(l => l.code === code);
    if (lang && onChange) {
      onChange(lang);
    }
  }

  function selectMultipleLanguages(codes) {
    setSelectedLanguageCode(codes);
    const langs = languages.filter(l => codes.includes(l.code));
    onChange?.(langs);
  }

  return {
    languages,
    selectedLanguageCode,
    selectLanguage,
    selectMultipleLanguages,
  };
}
